import { CREATE_EXAMINATION_ASSIGNMENT_USE_CASE, CREATE_PRACTICE_ASSIGNMENT_USE_CASE, CreateExaminationAssignmentUseCase, CreatePracticeAssignmentUseCase, EXAMINATION_ASSIGNMENT_REPOSITORY, PRACTICE_ASSIGNMENT_REPOSITORY } from '@module/assignment';
import { FORM_RELEASE_REPOSITORY } from '@module/form';
export var assignmentUseCaseProviders = [{
  provide: CREATE_PRACTICE_ASSIGNMENT_USE_CASE,
  useFactory: function useFactory(practiceAssignmentRepository, formReleaseRepository) {
    return new CreatePracticeAssignmentUseCase(practiceAssignmentRepository, formReleaseRepository);
  },
  inject: [PRACTICE_ASSIGNMENT_REPOSITORY, FORM_RELEASE_REPOSITORY]
}, // Examination assignment
{
  provide: CREATE_EXAMINATION_ASSIGNMENT_USE_CASE,
  useFactory: function useFactory(examinationAssignmentRepository, formReleaseRepository) {
    return new CreateExaminationAssignmentUseCase(examinationAssignmentRepository, formReleaseRepository);
  },
  inject: [EXAMINATION_ASSIGNMENT_REPOSITORY, FORM_RELEASE_REPOSITORY]
}];